import { FC, ReactNode } from 'react'

import clsx from 'clsx'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'

import s from './styles.module.scss'

export interface Props {
  title?: string
  onClick?: (key: string) => void
  listContent?: {
    icon: ReactNode
    name: string
    key: string
    additional?: string
    isNew?: boolean
  }[]
}

export const BlockArrows: FC<Props> = ({ title, listContent, onClick }) => (
  <div className={s.container}>
    <p className={clsx(s.title, 'bold-17')}>{title}</p>

    <div className={s.wrapper}>
      {listContent?.map((item) => (
        <div
          key={item.key}
          onClick={() => onClick?.(item.key)}
          className={s.item}
        >
          <div className={s.left}>{item.icon}</div>

          <div className={s.right}>
            <p className={clsx('regular-16')}>{item.name}</p>

            <div className={s.additional}>
              {item.isNew && (
                <span className={clsx(s.newBadge, 'medium-12')}>New</span>
              )}
              <span className={s.text}>{item.additional}</span>

              <AppIcon
                id={AllIcons.ARROW_RIGHT}
                height={20}
                width={20}
                color="var(--grey-3)"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
)
